module.exports = __webpack_public_path__ + "static/media/loader.459e0ba8.gif";